import { newId } from '@quickreport/domain';
import { queueChange, type Tx } from '@quickreport/sync';

export interface AuditInput {
  entity: string;
  entityId: string;
  action: string;
  before?: unknown;
  after?: unknown;
  reason?: string;
}

/**
 * Append to the audit trail in the same transaction as the change it describes. The trail
 * syncs like any other data and can never be edited afterwards (the server refuses it).
 */
export async function recordAudit(
  tx: Tx,
  orgId: string,
  who: { userId: string; deviceId?: string | null },
  e: AuditInput,
): Promise<void> {
  const id = newId();
  await tx.query(
    `insert into audit_events (id, org_id, actor, device_id, entity, entity_id, action, before, after, reason)
     values ($1, $2, $3, $4, $5, $6, $7, $8::jsonb, $9::jsonb, $10)`,
    [
      id,
      orgId,
      who.userId,
      who.deviceId ?? null,
      e.entity,
      e.entityId,
      e.action,
      e.before === undefined ? null : JSON.stringify(e.before),
      e.after === undefined ? null : JSON.stringify(e.after),
      e.reason ?? null,
    ],
  );
  await queueChange(tx, 'audit_events', id);
}
